/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { CitationDto } from '../model/citationDto';
// @ts-ignore
import { CitationOfficerDto } from '../model/citationOfficerDto';
// @ts-ignore
import { CitationPagedResultDto } from '../model/citationPagedResultDto';

// @ts-ignore
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({ providedIn: 'root' })
export class CitationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    public apiCitationGet(
        issuedFrom?: string,
        issuedTo?: string,
        status?: string,
        officerId?: number,
        plate?: string,
        skipCount?: number,
        maxResultCount?: number,
        sorting?: string,
        observe?: 'body', reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }
    ): Observable<CitationPagedResultDto>;
    public apiCitationGet(
        issuedFrom?: string, issuedTo?: string, status?: string, officerId?: number, plate?: string,
        skipCount?: number, maxResultCount?: number, sorting?: string,
        observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }
    ): Observable<HttpResponse<CitationPagedResultDto>>;
    public apiCitationGet(
        issuedFrom?: string, issuedTo?: string, status?: string, officerId?: number, plate?: string,
        skipCount?: number, maxResultCount?: number, sorting?: string,
        observe: any = 'body', reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }
    ): Observable<any> {
        let params = new HttpParams({ encoder: this.encoder });
        if (issuedFrom != null) params = params.set('issuedFrom', issuedFrom);
        if (issuedTo != null) params = params.set('issuedTo', issuedTo);
        if (status != null && status !== 'All') params = params.set('status', status);
        if (officerId != null) params = params.set('officerId', String(officerId));
        if (plate != null) params = params.set('plate', plate);
        if (skipCount != null) params = params.set('skipCount', String(skipCount));
        if (maxResultCount != null) params = params.set('maxResultCount', String(maxResultCount));
        if (sorting != null) params = params.set('sorting', sorting);

        let headers = this.defaultHeaders;
        headers = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', headers, 'Bearer ');

        const accept = options?.httpHeaderAccept ?? 'application/json';
        if (accept) headers = headers.set('Accept', accept);

        return this.httpClient.request<CitationPagedResultDto>('get', `${this.configuration.basePath}/api/citation`, {
            context: options?.context ?? new HttpContext(),
            params,
            responseType: 'json',
            withCredentials: this.configuration.withCredentials,
            headers,
            observe,
            reportProgress
        });
    }

    public apiCitationIdGet(id: number, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }): Observable<any> {
        let headers = this.defaultHeaders;
        headers = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', headers, 'Bearer ');
        const accept = options?.httpHeaderAccept ?? 'application/json';
        if (accept) headers = headers.set('Accept', accept);

        return this.httpClient.request<CitationDto>('get', `${this.configuration.basePath}/api/citation/${encodeURIComponent(String(id))}`, {
            context: options?.context ?? new HttpContext(),
            responseType: 'json',
            withCredentials: this.configuration.withCredentials,
            headers,
            observe,
            reportProgress
        });
    }

    public apiCitationOfficersGet(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }): Observable<any> {
        let headers = this.defaultHeaders;
        headers = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', headers, 'Bearer ');
        const accept = options?.httpHeaderAccept ?? 'application/json';
        if (accept) headers = headers.set('Accept', accept);

        return this.httpClient.request<CitationOfficerDto[]>('get', `${this.configuration.basePath}/api/citation/officers`, {
            context: options?.context ?? new HttpContext(),
            responseType: 'json',
            withCredentials: this.configuration.withCredentials,
            headers,
            observe,
            reportProgress
        });
    }

    public apiCitationIdVoidPost(id: number, reason: string, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json', context?: HttpContext }): Observable<any> {
        let headers = this.defaultHeaders;
        headers = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', headers, 'Bearer ');
        headers = headers.set('Content-Type', 'application/json');
        const accept = options?.httpHeaderAccept ?? 'application/json';
        if (accept) headers = headers.set('Accept', accept);

        return this.httpClient.request<CitationDto>('post', `${this.configuration.basePath}/api/citation/${encodeURIComponent(String(id))}/void`, {
            context: options?.context ?? new HttpContext(),
            body: { reason },
            responseType: 'json',
            withCredentials: this.configuration.withCredentials,
            headers,
            observe,
            reportProgress
        });
    }
}
